import React, { useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import './../styles/info-tabs.css';

function InfoTabs({ tabs = [], className = '' }) {
  const [currentTab, setCurrentTab] = useState(tabs[0]?.value);
  const handleToggleChange = (e) => {
    setCurrentTab(e.target.value);
  }

  return (
    <section className={`${className ? className : ''} info-tabs-container`}>
      <Grid container className="info-tabs-toggle-wrapper">
        <div className="info-tabs-toggle-container">
          <ToggleButtonGroup
            color="primary"
            value={currentTab}
            exclusive
            onChange={handleToggleChange}
            aria-label="Product Information Tabs"
            className="info-tabs-toggle-group"
          >
            {tabs.map(tab => {
              return (
                <ToggleButton
                  key={tab.value}
                  className="info-tabs-toggle-button"
                  value={tab.value}
                >
                  {tab.name}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>
        </div>
      </Grid>
      <Grid container className="info-tabs-text-wrapper">
        {tabs.map(tab => {
          return (
            <div
              key={tab.value}
              className={`info-tabs-text-container ${currentTab === tab.value ? 'is-active' : ''}`}
              dangerouslySetInnerHTML={{ __html: tab.html}}
            />
          );
        })}
      </Grid>
    </section>
  )
}

export default InfoTabs
